export const mobileRegex: RegExp = /^\+?[1-9]\d{1,14}$/;

export const emailRegex: RegExp = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

export const passwordRegex: RegExp =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*]).{8,20}$/;

export const alphabetsRegex: RegExp = /^[a-zA-Z]+$/;

export const numberRegex: RegExp = /^\d+$/;

export const floatingPointNumberRegex: RegExp = /^(?:\d+(?:\.\d{1,3})?|\.\d+)$/;

export const zipCodeRegex: RegExp = /^[A-Za-z0-9\s-]{3,10}$/;

// Rejects a value that starts with whitespace, which also covers a
// whitespace-only value like "   " (`required` alone lets that through).
// Spaces inside the value are fine, e.g. "Meher Anand". Pair with
// `.trim()` on submit to drop any trailing space.
export const noLeadingSpaceRegex: RegExp = /^\S/;
